import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import HlsVideo from "../components/HlsVideo";
import { ArrowLeft, Heart } from "lucide-react";
import { resolveUrl } from "../lib/url";

export default function LivePlayerPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [channel, setChannel] = useState(null);
  const [fav, setFav] = useState(false);

  useEffect(() => {
    api.get(`/channels/${id}`).then((r) => setChannel(r.data));
  }, [id]);

  if (!channel) return <div className="min-h-screen bg-[#050505]" />;

  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="live-player-page">
      <div className="flex items-center gap-4 px-4 sm:px-8 py-4 border-b border-white/5 bg-black/40 sticky top-0 z-30 backdrop-blur-md">
        <button onClick={() => navigate(-1)} className="text-white" data-testid="live-back-btn"><ArrowLeft /></button>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <span className="live-badge">LIVE</span>
            <h1 className="text-lg font-bold" style={{ fontFamily: "Outfit" }}>{channel.channelName}</h1>
          </div>
          <div className="text-xs text-[#999] mt-0.5">{channel.country} • {channel.category} • {channel.language}</div>
        </div>
        <button onClick={() => setFav(!fav)} className={`p-2 rounded ${fav ? "text-[#E50914]" : "text-[#888]"} hover:bg-white/5`} data-testid="favorite-channel-btn">
          <Heart className={fav ? "fill-[#E50914]" : ""} size={20} />
        </button>
      </div>

      <div className="grid lg:grid-cols-[1fr_360px] gap-0">
        <div className="bg-black aspect-video lg:aspect-auto lg:h-[calc(100vh-72px)]">
          <HlsVideo
            src={resolveUrl(channel.streamUrl)}
            controls
            autoPlay
            className="w-full h-full bg-black object-contain"
            data-testid="live-video"
          />
        </div>
        <aside className="bg-[#0a0a0a] border-l border-white/5 p-6 overflow-y-auto lg:h-[calc(100vh-72px)]" data-testid="channel-epg">
          <h2 className="text-sm font-bold uppercase tracking-wider text-[#E50914] mb-4">Program Guide</h2>
          <div className="space-y-3">
            {(channel.schedule || []).map((p, i) => (
              <div key={i} className={`p-3 rounded-lg border ${i === 1 ? "border-[#E50914] bg-[#E50914]/10" : "border-white/5 bg-[#111]"}`}>
                <div className="text-xs text-[#999] mb-1">{p.startTime} – {p.endTime}</div>
                <div className="font-semibold">{p.programTitle}</div>
                <div className="text-xs text-[#aaa] mt-1">{p.description}</div>
                {i === 1 && <span className="text-xs text-[#E50914] font-bold mt-2 inline-block">● ON NOW</span>}
              </div>
            ))}
          </div>
          <div className="mt-8">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-3">About this channel</h3>
            <p className="text-sm text-[#aaa] leading-relaxed">
              {channel.channelName} broadcasts from {channel.country} in {channel.language}. Tune in for {channel.category.toLowerCase()} content all day, every day.
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
}
